import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

 
export const CreateMemberVaccination = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MemberVaccination/Create`, data);

export const UpdateMemberVaccination = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MemberVaccination/Update`, data);

export const RevertMemberVaccination = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MemberVaccination/RevertVaccination`, data);